import { partnerDisplayNames } from '../constants';
import { PartnerOrganization } from '../types/partnerType.type';

export const checkCorrectUserGroupName = (pattern: string): RegExpMatchArray | null => {
  const regex = /^[^:]+:([^:]+):[^:]+$/;
  return pattern.match(regex);
};

export const getOrganizationNameFromUserGroup = (pattern: string): string | undefined => {
  const match = checkCorrectUserGroupName(pattern);

  return match ? match[1] : undefined;
};

export const getDisplayNameByPartnerOrganization = (partner: PartnerOrganization): string => {
  return (
    partnerDisplayNames[partner as unknown as string] ||
    (partner as unknown as string)
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
};
